import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @Input() component: any;
  @Input() formDesign: any;
  @Output() onChangeEmitter: any = new EventEmitter();
  @Input() formState: any;

  myState: any = "";
  
  constructor() {}

  ngOnInit() {
    if(this.formState) {
      this.myState = this.sanityForAmount(this.formState[this.component.element.field_name]) ?? ''
    }
  }

  ngOnChanges(c: any) {
    if(this.formState) {
      this.myState = this.sanityForAmount(this.formState[this.component.element.field_name]) ?? ''
    }
  }

  sanityForAmount(value: any) {
    if(this.component.type == 'amount') {
      let val = Number(value?.toString().replaceAll(',',''))
      return isNaN(val) ? 0 : val
    } 
    return value
  }

  onChange(e: any) {
    this.onChangeEmitter.emit({ 
      component: this.component, 
      eventType: "valueChange",
      value: e.value ?? e.target.value })
  }

  validateAmount() {
    return true
  }

  customCallback(e: any) {
    return true;
  }
}
